// ─────────────────────────────────────────────────────────────
// Content config for each offer detail page (/offre/:key)
// iOS-menu style — every item = colored square icon + title + subtitle
// ─────────────────────────────────────────────────────────────

export const OFFERS_DETAIL = {

  // ══════════════ EBOOK 147€ ══════════════
  ebook: {
    key: 'ebook',
    kicker: 'PDF · 70 PAGES',
    title: 'La méthode complète du restaurant 2026.',
    tagline: 'Resto rentable · marges 70% · marque virale et duplicable.',
    heroBg: 'radial-gradient(120% 80% at 50% 0%, #1a3d2b 0%, #0a2418 60%, #051b10 100%)',
    accent: '#10B981',
    accentText: '#FFFFFF',
    price: {
      main: '147€',
      sub: 'TTC · unique · pas d\'abonnement',
    },
    ctaLabel: '📖 Acheter l\'ebook · 147€ TTC',
    ctaAction: 'ebook-checkout',
    stats: [
      { value: '70',  label: 'Pages' },
      { value: '12',  label: 'Schémas' },
      { value: '6',   label: 'Bonus' },
    ],
    sections: [
      {
        title: 'Les 5 questions qu\'on te répond',
        items: [
          { icon: '📕', color: '#10B981', title: 'Où est le manuel de mon resto en 2026 ?',      sub: 'Un PDF 70 pages ultra-illustré · immédiat après paiement',
            action: '📕 Je te livre le PDF complet en 30 secondes' },
          { icon: '📊', color: '#3B82F6', title: 'Comment lire mes chiffres en un coup d\'œil ?', sub: '12 schémas visuels · matrices · food cost · timelines',
            action: '📊 J\'ai décodé les KPI pour toi' },
          { icon: '🎯', color: '#F59E0B', title: 'Que faire concrètement les 30 prochains jours ?', sub: 'Plan jour par jour · actions concrètes · résultats mesurables',
            action: '🎯 Je te donne le plan 30j clé en main' },
          { icon: '🎁', color: '#EF4444', title: 'Existe-t-il des méthodes prêtes à copier ?',    sub: 'Fiche recette · onboarding 7j · règle 30/30/30/10 · +3 autres',
            action: '🎁 Je te partage mes 6 méthodes signature' },
          { icon: '♾️', color: '#6B7280', title: 'Puis-je re-télécharger à volonté ?',            sub: 'Lien sécurisé unique par acheteur · mises à jour incluses',
            action: '♾️ Je te garantis l\'accès à vie' },
        ],
      },
      {
        title: 'Comment ça se passe',
        items: [
          { icon: '1', color: '#10B981', title: 'Paiement Stripe sécurisé', sub: '147€ TTC · 30 secondes' },
          { icon: '2', color: '#3B82F6', title: 'Email + PDF instantané',   sub: 'Lien sécurisé unique par acheteur' },
          { icon: '3', color: '#F59E0B', title: 'Tu exécutes',              sub: '30 jours de plan structuré · résultats mesurables' },
        ],
      },
      {
        title: 'Ce qui est dedans',
        items: [
          { icon: '🧬', color: '#10B981', title: 'ADN & positionnement',  sub: 'Trouver ton axe de marque unique' },
          { icon: '💰', color: '#F59E0B', title: 'Food cost & marges',    sub: 'Descendre à 25% food cost sans sacrifier la qualité' },
          { icon: '📖', color: '#3B82F6', title: 'Menu gagnant',          sub: 'Structure, prix, upsell — méthode complète' },
          { icon: '🎨', color: '#8B5CF6', title: 'Marque virale',         sub: 'Le playbook pour devenir mémorable en 6 mois' },
          { icon: '👥', color: '#EF4444', title: 'Équipe performante',    sub: 'Recrutement, formation, culture · zéro turnover' },
          { icon: '🌐', color: '#06B6D4', title: 'Duplication & franchise', sub: 'Systématiser pour scaler' },
        ],
      },
    ],
    testimonial: {
      quote: 'Le book pour un resto rentable, structuré, une marque virale — gros CA · marges 70% · équipe performante.',
      author: 'Sabril Jurczeszyn',
      role: 'Audit resto · 180+ restos audités',
    },
  },

  // ══════════════ ÉCONOMIE ══════════════
  economie: {
    key: 'economie',
    kicker: '48H EXPRESS · CLASSE ÉCONOMIE',
    title: 'L\'audit express + la méthode complète de ton resto.',
    tagline: '48h sur place · document dédié à ta marque · 30j de suivi WhatsApp · déductible.',
    heroBg: 'radial-gradient(120% 80% at 50% 0%, #0F7A78 0%, #062626 60%, #030f0f 100%)',
    accent: '#0F7A78',
    accentText: '#FFFFFF',
    price: {
      main: 'dès 2 000€',
      sub: 'TTC · MA 2 190€ · FR·ES 2 790€ · 100% déductible',
    },
    ctaLabel: '✈️ Réserver mon audit',
    ctaAction: 'economie-checkout',
    stats: [
      { value: '48h', label: 'Sur place' },
      { value: '1',   label: 'Document dédié' },
      { value: '30j', label: 'Suivi WhatsApp' },
    ],
    sections: [
      {
        title: 'Les 11 questions qu\'on répond ensemble',
        items: [
          { icon: '🏠', color: '#0F7A78', title: 'On passe 48h dans ton resto',              sub: 'Immersion complète · shadow service · analyse terrain à tes côtés',
            action: '📍 Je viens 48h chez toi, non-stop' },
          { icon: '🔍', color: '#3B82F6', title: 'Où part vraiment ton argent chaque mois ?', sub: 'Audit 360° · P&L décortiqué · identification des fuites',
            action: '📊 Je chiffre tes fuites, ligne par ligne' },
          { icon: '📖', color: '#F59E0B', title: 'Quels sont tes 6 plats gagnants sur 8 ?',   sub: 'Menu gagnant · matrice star/puzzle · repositionnement prix',
            action: '📖 Je réécris ton menu et je le chiffre' },
          { icon: '🎯', color: '#8B5CF6', title: 'Ton concept correspond-il vraiment à ta cible ?', sub: 'Analyse concept + cible + adéquation offre-marché',
            action: '🎯 J\'identifie ta cible et j\'aligne ton concept' },
          { icon: '🧬', color: '#EF4444', title: 'Quel positionnement pour t\'imposer face à la concurrence ?', sub: 'Positionnement unique · défendable · mémorable · scalable',
            action: '🧬 Je construis ton positionnement de marque' },
          { icon: '💰', color: '#10B981', title: 'À combien devrait tourner ton food cost réel ?', sub: 'Food cost · matières premières · marges 70% · règles clés',
            action: '💰 Je remets tes marges à 70%' },
          { icon: '👥', color: '#06B6D4', title: 'Tes équipes savent-elles précisément ce qu\'elles doivent faire ?', sub: 'Fiches de poste claires · rôles · KPI · rituels de management',
            action: '👥 Je te guide sur les bonnes fiches de poste' },
          { icon: '⚖️', color: '#F97316', title: 'Comment éviter les erreurs de staffing coûteuses ?', sub: 'Sizing équipe · plannings · optimisation masse salariale',
            action: '⚖️ J\'optimise ta masse salariale' },
          { icon: '📈', color: '#EC4899', title: 'Comment attirer plus de clients sans exploser ton budget ?', sub: 'Stratégie marketing complète · acquisition · fidélisation · notoriété',
            action: '📈 Je te guide sur ta stratégie marketing gagnante' },
          { icon: '🎨', color: '#7C3AED', title: 'Ta direction artistique renvoie-t-elle la bonne image ?', sub: 'DA visuelle · charte · calendrier éditorial · guidelines réseaux',
            action: '🎨 Je pose ta charte visuelle & édito' },
          { icon: '👑', color: '#B45309', title: 'Comment déléguer, former et manager sans t\'épuiser ?', sub: 'Stratégie du bon dirigeant · autonomie équipe · scaler ton temps',
            action: '👑 Je te forme au pilotage de dirigeant' },
        ],
      },
      {
        title: 'Ce qu\'on te transmet (livrables)',
        items: [
          { icon: '📕', color: '#0F7A78', title: 'Document complet dédié à ta marque', sub: 'PDF sur-mesure · ta stratégie · ton positionnement · ta feuille de route' },
          { icon: '📖', color: '#3B82F6', title: 'Guide menu gagnant',                sub: 'Structure de carte · matrice star/puzzle · repositionnement prix' },
          { icon: '👥', color: '#F59E0B', title: 'Trame fiches de poste',            sub: 'Le modèle à suivre pour structurer chaque rôle de ton équipe' },
          { icon: '💰', color: '#10B981', title: 'Grille food cost + marges',        sub: 'Le référentiel chiffré pour atteindre 70% de marges' },
          { icon: '🎨', color: '#8B5CF6', title: 'Direction artistique cadrée',      sub: 'Recommandations charte visuelle & calendrier éditorial' },
          { icon: '🎬', color: '#EF4444', title: 'Clés d\'un bon opening',           sub: 'Si projet d\'ouverture · timing · communication · lancement' },
          { icon: '💬', color: '#06B6D4', title: '30 jours de suivi WhatsApp',       sub: 'Réponses à toutes tes questions pendant 30 jours' },
        ],
      },
      {
        title: 'Le déroulé',
        items: [
          { icon: 'J-7', color: '#0F7A78', title: 'Préparation dossier',       sub: 'Tu m\'envoies P&L, carte, photos, contexte' },
          { icon: 'J+0', color: '#3B82F6', title: '48h sur place',             sub: 'Immersion · shadow service · analyses terrain' },
          { icon: 'J+7', color: '#F59E0B', title: 'Livraison du document',    sub: 'Ton PDF sur-mesure + tous les livrables annexes' },
          { icon: '30j', color: '#8B5CF6', title: 'Suivi WhatsApp illimité',   sub: 'Je reste dispo pour cadrer l\'exécution' },
        ],
      },
      {
        title: '💎 Ton avantage clé',
        items: [
          { icon: '↑', color: '#10B981', title: '100% déductible d\'une offre supérieure', sub: 'Si tu prends Classe Affaires ou Première Classe après, ton audit est intégralement crédité sur le nouveau devis.' },
          { icon: '🎁', color: '#F59E0B', title: 'Aucun engagement au-delà',              sub: 'Tu paies 48h, tu obtiens tout. Libre de choisir la suite.' },
          { icon: '⚡', color: '#3B82F6', title: 'Retour sur investissement rapide',       sub: 'Objectif : identifier 8 000€/mois de fuites en 2 jours' },
        ],
      },
      {
        title: '✈️ On s\'organise ensemble',
        subtitle: 'Logement + transport réservés à ton initiative, à mon nom — plus simple pour tout le monde',
        items: [
          { icon: '🏨', color: '#F59E0B', title: 'Logement pendant les 48h', sub: 'Tu réserves un hôtel 3★+ à mon nom, à proximité du restaurant. Ça t\'évite les frais bancaires internationaux liés à un remboursement.' },
          { icon: '✈️', color: '#3B82F6', title: 'Vol / train depuis Marrakech', sub: 'Réservation à mon nom (Sabril Jurczeszyn) pour l\'aller/retour — obligatoire pour l\'embarquement.' },
          { icon: '🚕', color: '#10B981', title: 'Trajets locaux sur place', sub: 'Petits déplacements logement ↔ restaurant · VTC, taxi, ou véhicule que tu mets à disposition. On voit ça ensemble.' },
        ],
      },
    ],
    testimonial: {
      quote: '48h suffisent pour identifier 8 000€/mois de fuites cachées et te livrer la méthode complète de ton resto. Tu repars avec un plan que tu peux exécuter seul — ou avec moi.',
      author: 'Sabril Jurczeszyn',
      role: 'Audit resto',
    },
  },

  // ══════════════ AFFAIRES ══════════════
  affaires: {
    key: 'affaires',
    kicker: 'CLASSE AFFAIRES · 90J DISTANCIEL',
    title: 'Ton bras droit stratégique à distance.',
    tagline: '90 jours de pilotage rapproché · WhatsApp prioritaire · sur-mesure.',
    heroBg: 'radial-gradient(120% 80% at 50% 0%, #3530A8 0%, #161232 55%, #08051c 100%)',
    accent: '#8B5CF6',
    accentText: '#FFFFFF',
    price: {
      main: 'sur mesure',
      sub: 'devis 24h · pas d\'abonnement',
    },
    ctaLabel: '📩 Demander mon devis',
    ctaAction: 'affaires-quote',
    stats: [
      { value: '90j', label: 'Pilotage' },
      { value: '2',   label: 'RDV/mois' },
      { value: '∞',   label: 'WhatsApp' },
    ],
    sections: [
      {
        title: 'Les 6 questions qu\'on répond en 90 jours',
        items: [
          { icon: '🎯', color: '#8B5CF6', title: 'Qui va vraiment piloter ma transformation ?', sub: '90 jours de pilotage rapproché · Sabril orchestre à distance',
            action: '🎯 Je pilote ta transformation de A à Z' },
          { icon: '💬', color: '#10B981', title: 'Puis-je avoir un vrai expert au bout du fil ?', sub: 'WhatsApp prioritaire · réponse <24h · direct Sabril',
            action: '💬 Je suis dispo WhatsApp <24h' },
          { icon: '📞', color: '#3B82F6', title: 'À quelle fréquence on cale ma stratégie ?',    sub: '2 RDV visio structurés par mois · comptes-rendus',
            action: '📞 Je te vois 2x par mois en visio' },
          { icon: '🧭', color: '#F59E0B', title: 'Comment prendre du recul chaque semaine ?',    sub: '1h de coaching dirigeant hebdomadaire',
            action: '🧭 Je te coache 1h chaque semaine' },
          { icon: '📊', color: '#EF4444', title: 'Comment savoir si mes chiffres progressent ?',  sub: 'Suivi hebdomadaire KPI · marges · CA · panier · food cost',
            action: '📊 Je surveille tes KPI chaque semaine' },
          { icon: '🎨', color: '#06B6D4', title: 'Sur quels chantiers on focus vraiment ?',      sub: 'Choix sur-mesure parmi mes 12 domaines d\'expertise',
            action: '🎨 J\'attaque les chantiers qui rapportent' },
        ],
      },
      {
        title: 'Les 12 chantiers activables',
        items: [
          { icon: '00', color: '#8B5CF6', title: 'Coaching dirigeant',         sub: 'Cadre de pilotage & prise de recul' },
          { icon: '01', color: '#10B981', title: 'ADN & histoire de marque',   sub: 'Positionnement unique, mémorable, cohérent' },
          { icon: '02', color: '#3B82F6', title: 'Expérience au sein du lieu', sub: 'Parcours client, service, ambiance' },
          { icon: '04', color: '#F59E0B', title: 'Menu gagnant',               sub: 'Structure, prix, upsell · matrice star/puzzle' },
          { icon: '05', color: '#EF4444', title: 'Food cost & marges',         sub: 'Descendre à 25-28% food cost sans compromis' },
          { icon: '06', color: '#06B6D4', title: 'RH & performance équipe',    sub: 'Recrutement, fiches de poste, culture' },
        ],
      },
      {
        title: 'Le déroulé 90 jours',
        items: [
          { icon: 'S0',    color: '#8B5CF6', title: 'Kickoff & audit distanciel', sub: 'Cadrage périmètre · état des lieux · priorisation' },
          { icon: 'M1',    color: '#3B82F6', title: 'Chantiers prioritaires',    sub: 'Attaque des chantiers cœur de sujet' },
          { icon: 'M2',    color: '#F59E0B', title: 'Exécution & itération',     sub: 'Tests · ajustements · consolidation' },
          { icon: 'M3',    color: '#10B981', title: 'Consolidation & passation', sub: 'Cristallisation des acquis · plan post-mission' },
        ],
      },
    ],
    testimonial: {
      quote: 'Le coaching distanciel exigeant — comme si j\'étais ton bras droit, mais à distance.',
      author: 'Sabril Jurczeszyn',
      role: 'Audit resto',
    },
  },

  // ══════════════ PREMIÈRE ══════════════
  premiere: {
    key: 'premiere',
    kicker: 'PREMIÈRE CLASSE · 7J + 10J SUR PLACE',
    title: 'L\'offre signature. Transformation totale.',
    tagline: 'Immersion physique · refonte au scalpel · marque livrée clé en main.',
    heroBg: 'radial-gradient(120% 80% at 50% 0%, #6B330A 0%, #2a1502 55%, #110900 100%)',
    accent: '#F59E0B',
    accentText: '#FFFFFF',
    price: {
      main: 'sur mesure',
      sub: 'café de calibrage · devis 48h',
    },
    ctaLabel: '📞 Réserver mon café de calibrage',
    ctaAction: 'premiere-quote',
    stats: [
      { value: '7+10j', label: 'Sur place' },
      { value: '12',    label: 'Chantiers' },
      { value: '90j',   label: 'Suivi' },
    ],
    sections: [
      {
        title: 'Les 7 questions qu\'on t\'engage à traiter',
        items: [
          { icon: '👑', color: '#F59E0B', title: 'Vais-je enfin bénéficier d\'une vraie présence physique ?', sub: '7 jours pour lancer + 10 jours pour livrer sur ton terrain',
            action: '👑 Je viens 7j + 10j sur place, à tes côtés' },
          { icon: '🎯', color: '#8B5CF6', title: 'Quels chantiers concrets vont vraiment être menés ?',       sub: 'Choix à la carte parmi mes 12 domaines d\'expertise',
            action: '🎯 J\'attaque tous les chantiers qu\'on aura définis' },
          { icon: '👥', color: '#10B981', title: 'Mon équipe va-t-elle être formée directement ?',           sub: 'Shadowing · coaching in situ · rituels de management',
            action: '👥 Je forme ton équipe sur le terrain' },
          { icon: '🧬', color: '#3B82F6', title: 'Comment on repositionne ma marque de zéro ?',              sub: 'ADN, storytelling, identité complète refonte',
            action: '🧬 Je refonds ton ADN et ton positionnement' },
          { icon: '🎨', color: '#EF4444', title: 'Ma direction artistique sera-t-elle enfin cohérente ?',    sub: 'DA visuelle · calendrier éditorial · asset library complète',
            action: '🎨 Je pose ta charte visuelle & édito' },
          { icon: '🎬', color: '#06B6D4', title: 'Vais-je être seul le jour de l\'ouverture ?',              sub: 'Présence Sabril sur place le jour J si ouverture',
            action: '🎬 Je suis là avec toi le jour J' },
          { icon: '📞', color: '#6B7280', title: 'Que se passe-t-il après la mission ?',                      sub: 'WhatsApp prioritaire pendant 90 jours après livraison',
            action: '📞 Je reste dispo 90j en priorité absolue' },
        ],
      },
      {
        title: 'Les 12 chantiers · qu\'est-ce qu\'on va t\'apporter ?',
        items: [
          { icon: '00', color: '#F59E0B', title: 'Comment mieux piloter ton restaurant sans t\'épuiser ?',    sub: 'Cadre de pilotage dirigeant · prise de recul · priorisation' },
          { icon: '01', color: '#8B5CF6', title: 'Quelle est vraiment ton histoire de marque ?',              sub: 'ADN · storytelling · positionnement unique et mémorable' },
          { icon: '02', color: '#3B82F6', title: 'Que ressent ton client au moment où il pousse ta porte ?',  sub: 'Parcours client · service · ambiance · touches de wow' },
          { icon: '03', color: '#10B981', title: 'Ton espace raconte-t-il ton concept ?',                     sub: 'Design intérieur · circulation · zones · signalétique' },
          { icon: '04', color: '#EF4444', title: 'Ton menu vend-il vraiment ce qu\'il devrait vendre ?',      sub: 'Menu gagnant · structure · prix · upsell · matrice star/puzzle' },
          { icon: '05', color: '#06B6D4', title: 'Tes marges tiennent-elles la route en 2026 ?',              sub: 'Food cost 25-28% · matières premières · règles clés' },
          { icon: '06', color: '#7C3AED', title: 'Ton équipe est-elle vraiment structurée pour performer ?',  sub: 'RH · recrutement · fiches de poste · culture · fidélisation' },
          { icon: '07', color: '#EC4899', title: 'Comment maîtriser la livraison sans y perdre ta marge ?',   sub: 'Uber Eats · Deliveroo · rentabilité plateforme par plateforme' },
          { icon: '08', color: '#F97316', title: 'Ton packaging travaille-t-il pour ta marque ?',             sub: 'Packaging · unboxing · cohérence DA · effet réseau social' },
          { icon: '09', color: '#B45309', title: 'Peux-tu extendre ta marque au-delà du resto ?',             sub: 'Merch · produits dérivés · lignes complémentaires' },
          { icon: '10', color: '#0F7A78', title: 'Ta communication en ligne raconte-t-elle une vraie histoire ?', sub: 'DA · calendrier éditorial · Instagram · TikTok · asset library' },
          { icon: '11', color: '#DC2626', title: 'Es-tu prêt à ouvrir sans rater ton lancement ?',            sub: 'Opening · communication pré-ouverture · jour J · post-lancement' },
        ],
      },
      {
        title: 'Le déroulé complet',
        items: [
          { icon: '1/2', color: '#F59E0B', title: 'Étape 1/2 · Café de calibrage', sub: '45min sur place · repérage terrain · cadrage' },
          { icon: '2/2', color: '#8B5CF6', title: 'Devis sur-mesure',              sub: 'Sous 48h après café · périmètre chiffré' },
          { icon: 'J+0', color: '#10B981', title: 'Kickoff 7j sur place',          sub: 'Immersion, audit terrain, lancement chantiers' },
          { icon: 'J+30', color: '#3B82F6', title: '60j coaching distanciel',      sub: 'Exécution · ajustements · itérations' },
          { icon: 'J+90', color: '#EF4444', title: '10j sur place · livraison',    sub: 'Finalisation · formation équipe · opening si besoin' },
          { icon: 'J+180', color: '#6B7280', title: '90j de suivi',                sub: 'WhatsApp priorité · point mensuel' },
        ],
      },
    ],
    testimonial: {
      quote: 'L\'offre signature — 7 jours pour lancer, 10 jours pour livrer. Ton resto transformé au scalpel.',
      author: 'Sabril Jurczeszyn',
      role: 'Audit resto',
    },
  },

  // ══════════════ SALON PRIVÉ ══════════════
  salon: {
    key: 'salon',
    kicker: 'SALON PRIVÉ · MENSUEL',
    title: 'Ton cerveau marketing externalisé.',
    tagline: 'Direction de marque continue · sans recruter · sans engagement.',
    heroBg: 'radial-gradient(120% 80% at 50% 0%, #3a4254 0%, #111827 55%, #030712 100%)',
    accent: '#94A3B8',
    accentText: '#FFFFFF',
    price: {
      main: '2 490€/mois',
      sub: 'Sans engagement · résiliable au mois',
    },
    ctaLabel: '💬 Discuter avec Sabril',
    ctaAction: 'open-chat',
    stats: [
      { value: '∞',    label: 'Accès' },
      { value: '24/7', label: 'WhatsApp' },
      { value: '1:1',  label: 'Sabril' },
    ],
    sections: [
      {
        title: 'Les 6 questions du dirigeant multi-sites',
        items: [
          { icon: '♾️', color: '#94A3B8', title: 'Puis-je avoir un accès Sabril illimité ?',           sub: 'Direct · sans intermédiaire · sans limite d\'échanges',
            action: '♾️ Je te donne un accès direct illimité' },
          { icon: '💬', color: '#10B981', title: 'Vais-je vraiment être en priorité absolue ?',       sub: 'Traitement prioritaire sur tous les autres clients',
            action: '💬 Je te traite en priorité absolue WhatsApp' },
          { icon: '🧠', color: '#3B82F6', title: 'Comment avoir un DG comm sans le recruter ?',        sub: 'Cerveau marketing externalisé à temps partagé',
            action: '🧠 Je deviens ton DG communication externalisé' },
          { icon: '📅', color: '#F59E0B', title: 'Aurai-je un plan clair chaque mois ?',              sub: 'Roadmap contenu · événements · DA · KPI documentés',
            action: '📅 Je te livre 1 stratégie mensuelle documentée' },
          { icon: '📊', color: '#EF4444', title: 'Comment savoir si ma marque progresse ?',            sub: 'Suivi hebdomadaire des indicateurs marque & acquisition',
            action: '📊 Je pilote tes KPI marque en continu' },
          { icon: '📸', color: '#8B5CF6', title: 'Qui va valider ma DA au quotidien ?',                sub: 'Feedback sur chaque asset · shooting · calendrier édito',
            action: '📸 Je valide toute ta direction artistique' },
        ],
      },
      {
        title: 'Livrables mensuels',
        items: [
          { icon: '📄', color: '#94A3B8', title: 'Stratégie du mois',           sub: 'Doc structuré : contenu · événements · dev · KPI' },
          { icon: '💡', color: '#F59E0B', title: 'Feedback sur décisions clés', sub: 'Chaque décision majeure passe par mon regard' },
          { icon: '🎯', color: '#10B981', title: 'Priorisation chantiers',      sub: 'Focus sur les 3 sujets à haut impact du mois' },
          { icon: '📈', color: '#3B82F6', title: 'Rapport mensuel synthétique', sub: 'Progression, victoires, points d\'attention' },
        ],
      },
      {
        title: 'Pour qui',
        items: [
          { icon: '🏢', color: '#94A3B8', title: 'Groupes multi-sites',          sub: '3+ restaurants · cohérence de marque à maintenir' },
          { icon: '🌱', color: '#10B981', title: 'Franchises en croissance',     sub: 'Duplication de concept · scaling maîtrisé' },
          { icon: '👑', color: '#F59E0B', title: 'Marques établies sans DG comm', sub: 'Pas encore le budget pour recruter en interne' },
        ],
      },
    ],
    testimonial: {
      quote: 'Pour les groupes qui veulent un cerveau marketing externe, à demeure, sans s\'embêter à recruter.',
      author: 'Sabril Jurczeszyn',
      role: 'Audit resto',
    },
  },

};

export default OFFERS_DETAIL;
